import { useState } from "react";
import { Auth } from "./auth";

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [username, setUsername] = useState("alastair");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await Auth.signIn(username, password);
      onSignedIn();
    } catch (e: any) {
      setErr(String(e?.message ?? e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="signin">
      <h1>Cut · 2026</h1>
      <form onSubmit={submit}>
        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {err && <div className="err">{err}</div>}
        <button type="submit" className="btn btn-accent" disabled={loading || !password}>
          {loading ? "…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
